import {
  REQUESTED_DOCUMENT_TASKS,
  TaskInstance,
  THREAD_DOCUMENT_TASKS,
} from '@data-access/tasks';
import { uniqueId } from 'lodash';
import { DocumentTypeExtended } from '../types';
import { sortEntityTypeDocuments } from '@data-access/shared';

export function buildDocumentsFromTasks(
  submissionIntId: string,
  uploadedRequiredTaskIds: string[],
  tasks: TaskInstance[],
  documentTypes: DocumentTypeExtended[],
  currentStage: string,
) {
  return sortEntityTypeDocuments(tasks)
    .filter((t) => !uploadedRequiredTaskIds.includes(t.id))
    .map((t) => {
      const documentType =
        documentTypes.find((dt) => dt.id === t.document_type_id) ?? null;
      const isHyperLink =
        currentStage === 'draft' ||
        (currentStage === 'qc_check' &&
          (REQUESTED_DOCUMENT_TASKS.has(t.task_type) ||
            THREAD_DOCUMENT_TASKS.has(t.task_type)));

      return {
        id: uniqueId(),
        data: {
          created_dt: null,
          data: {},
          entity_id: t.workspace_id ?? null,
          entity_type: 'workspace',
          file_hash: null,
          file_id: null,
          file_size: null,
          id: '',
          is_reviewer_document: null,
          mime_type: null,
          new_title: '',
          original_title: '',
          thumbnails: null,
          updated_dt: null,
          version_id: null,
        },
        int_id: null,
        legacy_id: null,
        location: '',
        name: null,
        wcg_name: '',
        title: 'Upload File',
        entity_id: t.workspace_id ?? null,
        created_dt: null,
        updated_dt: null,
        is_complete: false,
        is_deleted: null,
        is_response: null,
        is_outcome: null,
        is_additional: null,
        required: 'required',
        is_resolved: null,
        workspace_id: t.workspace_id ?? null,
        is_reviewer_document: null,
        complete_timestamp: null,
        transmitted_timestamp: null,
        entity_type: 'workspace',
        created_by_user: null,
        document_id: t.id,
        attribute_type: null,
        document_type: documentType,
        sites: null,
        messages: null,
        document_type_id: t.document_type_id,
        attribute_type_id: null,
        document_status: 'new_task',
        document_description: t.description ?? null,
        document_tasks: [],
        reviewed_date: null,
        transmitted_date: null,
        document_type_name: documentType?.name ?? '',
        task_title: t.title ?? '',
        task_titles: t.title ?? '',
        workspace_int_id: submissionIntId,
        attribute_name: '',
        task_id: t.id,
        need_to_upload: true,
        isNotHyperLink: !isHyperLink,
      };
    });
}
